import * as React from "react";
import styled from "styled-components";
import { useCalendarContext } from "../CalendarContext";
import { HourBloc } from "./HourBloc";

const Container = styled.div`
  border-bottom: 1px solid black;
`;

export const HoursColumn: React.FunctionComponent = () => {
  const { dayTimeSlices, sliceHeightInPx, keyColumnWidthInPx, hourLimit } =
    useCalendarContext();

  const hourSlices = React.useMemo(
    () => dayTimeSlices.filter((d) => d.isHour),
    [dayTimeSlices]
  );

  const numberOfInnerSlices = React.useMemo(
    () => dayTimeSlices.length / hourSlices.length,
    [dayTimeSlices.length, hourSlices.length]
  );
  const finalHeight = React.useMemo(
    () => sliceHeightInPx * numberOfInnerSlices,
    [numberOfInnerSlices, sliceHeightInPx]
  );

  const hoursBetweenDayLimit = React.useMemo(() => {
    if(hourLimit) return hourSlices.filter((i) => i.time.hours >= hourLimit.startHour && i.time.hours <= hourLimit.endHour)
    return hourSlices
  }, [hourSlices, hourLimit])

  return (
    <Container style={{ width: keyColumnWidthInPx }}>
      {hoursBetweenDayLimit.map((h, i) => (
        <HourBloc height={finalHeight} hour={h} key={h.time.hours} />
      ))}
    </Container>
  );
};
